module.exports = __webpack_public_path__ + "static/media/IMG_4594.31f846a4.jpg";